import {Controller} from "stimulus"
import AutoNumeric from "autonumeric"

let numberElements;


export default class extends Controller {

    connect() {
        console.log("log from bl-license_applications index controller");
    }



}
